import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const navigationPhasesSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'navigationPhases'

export const config = { site: navigationPhasesSiteConfig, name }
